@if (loaded) {
    <label class="form-label" for="site-assignment-list">{{ labelKey | translate }}</label>

    <div id="site-assignment-list">
        @for (site of sites; track site.id) {
            <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="site-assignment-{{site.id}}"
                       [ngModel]="selectedSiteIds.has(site.id)"
                       (ngModelChange)="onSiteToggle(site.id, $event)"
                       [disabled]="isDisabled">
                <label class="form-check-label" for="site-assignment-{{site.id}}">
                    {{ siteName(site) }}
                </label>
            </div>
        }
    </div>
}
